import { createAction, props } from '@ngrx/store';

export enum ConfigActionTypes {
    LoadDefaultProductPricingOptions = '[Config] LoadDefaultProductPricingOptions',
    LoadDefaultProductPricingOptionsSuccess = '[Config] LoadDefaultProductPricingOptionsSuccess',

    LoadConfigFailure = '[Config] LoadConfigFailure'
}
export const LoadDefaultProductPricingOptions = createAction(ConfigActionTypes.LoadDefaultProductPricingOptions);
export const LoadDefaultProductPricingOptionsSuccess = createAction(
    ConfigActionTypes.LoadDefaultProductPricingOptionsSuccess,
    props<{ result: string }>()
);
export const LoadConfigFailure = createAction(ConfigActionTypes.LoadConfigFailure, props<{ error: any }>());
